import {
    Inject,
    Component,
    ContentChildren,
    ContentChild,
    QueryList,
    Input,
    AfterContentInit, SimpleChanges,
    OnChanges,Output,EventEmitter
} from "@angular/core";

import { DataCollection } from './data-collection.abstract';
import { RxColumnComponent } from './rx-column.component';
import { RxTableDetailTemplateDirective } from './rx-table-detail-template.directive';
import { PermissionService } from '../security/permission.service';
import { user } from '../security/user';
import { ApplicationConfiguration } from "../core";
import { GridCode } from './grid-code.static.class';
import { DataSearch } from './models';
import { RxHttp } from '../http';
import { RxTableFooterTemplateDirective } from "@rx/table/table";

export const API_HOST_URI: string = 'API_URL';

@Component({
    selector: "rx-table",
    templateUrl: "./rx-table.component.html",
    exportAs: 'grid'
})
export class RxTableComponent extends DataCollection implements AfterContentInit, OnChanges {
    @ContentChildren(RxColumnComponent) columns: QueryList<RxColumnComponent>;

    @ContentChild(RxTableDetailTemplateDirective) detailTemplate: RxTableDetailTemplateDirective;

    @ContentChild(RxTableFooterTemplateDirective) footerTemplate: RxTableFooterTemplateDirective;

    @Input() dataSource: any;

    @Input() pageSize: number;

    @Input() defaultFilter: any;

    @Input() masterClass: any;

    @Input() controlClass: any;

    @Input() rowClass: string;

    @Input() isStoreProc: boolean;

    @Input() addRow: boolean;
	
	@Input() totalCount: number;

 	@Input() set isFilter(value: boolean){
        if(value)
          super.clearPageIndex();
    }

    @Output() pageChanging:EventEmitter<any> = new EventEmitter<any>()    

	tableConfiguration: any;

    addItem: any = {};

    pastSortableColumnComponent: RxColumnComponent;

    detailIndex: number = -1;

    openDetail: string;
    closeDetail: string;
    tableClass: string;
    isTypeCheck: boolean = false;
    firstTimeBind: boolean = false;
    isAddRow: boolean = false;

    constructor(private permissionService: PermissionService, http: RxHttp, @Inject(API_HOST_URI) hostUri: string) {
        super(http, hostUri);
        this.tableConfiguration = ApplicationConfiguration.get('control.rxTable');
        this.openDetail = this.tableConfiguration.masterClass.openDetail;
        this.closeDetail = this.tableConfiguration.masterClass.closeDetail;
        this.tableClass = this.tableConfiguration.controlClass.table;
		super.setEvents(this.pageChanging)
        //this.tableClass = "mdl-data-table product-table m-t-30 dataTable no-footer table table-striped";    
	}

    selectable: boolean = true;
    code: string;
    ngAfterContentInit(): void {
        super.setFooter();
        GridCode.code++;
        this.code = 'grid-' + GridCode.code;
        var actionColumns = this.columns.filter((t) => { return t.permissions != null && t.permissions.length > 0 });
        let permissionItems: any[] = [];
        if (actionColumns.length > 0)
            actionColumns.forEach((t) => {
                var count = 0;
                t.permissions.forEach((x) => {
                    if (this.permissionService.isAccess(x)) {
                        count++;
                    }
                });
                if (t.permissions.length == count)
                    t.isBindable = false;
            });
        actionColumns = this.columns.filter((t) => { return t.isBindable });
        this.columns.reset(actionColumns);
        if (this.addRow)
            this.columns.forEach(t => this.addItem[t.field] = '');
        
		if (!this.firstTimeBind && this.dataSource){
            this.bindData(this.dataSource);
		}

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["dataSource"]) {
            let source: any[] = changes['dataSource'].currentValue;

            this.bindData(source);
        }
    }

    exportToCsv(fileName: string) {
        super.export(this.columns, fileName.concat(".csv"));
    }

    showAddRow() {
        this.isAddRow = !this.isAddRow;
    }

    bindData(source: any[]) {
        let tableColumns = new Array<string>();
        let sortColumnName:string;
        if (this.columns) {
            if (source) {
                if (source.length > 0)
                    this.columns.forEach(t => {
                        if (t.sortable) {
                            sortColumnName = t.field;
                            t.sortClass = this.tableConfiguration.masterClass.asc;
                            this.pastSortableColumnComponent = t; //Bhagyashree
                        }
                        if (!t.actionable) {
                            let fieldValue = source[0][t.field];
                            if (!fieldValue) {
                                let findObject = source.filter(x => x[t.field] != null)[0];
                                if (findObject)
                                    fieldValue = findObject[t.field];
                                else
                                    fieldValue = '';
                            }
                            if (typeof fieldValue != "boolean" && typeof fieldValue != "number" && (fieldValue.split("/").length == 3 || fieldValue.split("-").length == 3) && new Date(fieldValue).toString() !== "Invalid Date") {
                                t.dataType = "date";
                            }
                            else
                                t.dataType = typeof fieldValue;
                            tableColumns.push(t.field);
                        }
                    });
                //super.set(source, this.pageSize, tableColumns);
				super.set(source, this.pageSize, tableColumns, this.isStoreProc, this.totalCount);
                if (sortColumnName)
                   super.sort(sortColumnName, true);
                else
                    super.pagging();

				super.applyChangesToObject(true);
                this.firstTimeBind = true;
            }
        }

    }

    search(jObject: any) {
        if (jObject instanceof Array) {
            super.filter(jObject);
        } else {
            for (var col in jObject) {
                var dataSearch = new DataSearch({ columnName: col, condition: "==", value: jObject[col] });
                super.filter(dataSearch);
            }
        }


    }

    reset() {
        super.resetTable();
    }

    searchAll(value: any) {
        super.filterAll(value);
    }

    setTableConfiguration() {
        if (this.masterClass)
            this.tableConfiguration.masterClass = this.masterClass;
        if (this.controlClass)
            this.tableConfiguration.controlClass = this.controlClass;
    }

    private sortColumn(column: RxColumnComponent) {
        if (!column.actionable) {
            if (this.pastSortableColumnComponent == undefined)
                this.pastSortableColumnComponent = column;
            else if (this.pastSortableColumnComponent.field != column.field)
                this.pastSortableColumnComponent.sortable = undefined;
            this.pastSortableColumnComponent = column;
            if (column.sortable) {
                column.sortable = super.sort(column.field, false), column.sortClass = this.tableConfiguration.masterClass.desc;
            }
            else if (column.sortable == undefined || column.sortable == false) {
                column.sortable = super.sort(column.field, true), column.sortClass = this.tableConfiguration.masterClass.asc;
            }

        }

    }

    getColumnClass(row: any, column: RxColumnComponent) {
        if (column.columnClass) {
            return this.getClass(row, column.columnClass);
        }
        return '';
    }

    getRowClass(row: any) {
        if (this.rowClass) {
            return this.getClass(row, this.rowClass);
        }
        return '';
    }

    getClass(row, expression) {
        var fun = new Function('row', "return " + expression);
        if (expression.trim().split(" ").length > 1) {
            fun = new Function('row', "return " + expression);
        } else {
            fun = new Function('row', "return " + "'" + expression + "'");
        }
        return fun(row);
    }

    showDetail(index: number) {
        if (this.detailIndex == -1)
            this.detailIndex = index;
        else if (this.detailIndex != index)
            this.detailIndex = index;
        else
            this.detailIndex = -1;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@rx/table/rx-table.component.ts